import axios from "axios";
import { configUrl } from "../../config";
// import { configUrl } from "../../config";

const BASE = `${configUrl.AssessmentServer}/api/UserPreference`;

export const getUserPreferences = async (exam, userId) => {
    try {
        const res = await axios.get(`${BASE}/getUserPreferences/${exam}/${userId}`);

        return res.data;
    } catch (error) {
        console.error("getUserPreferences error:", error?.response?.data || error.message);
    }
};

export const getUserAllotments = async (exam, userId) => {
    try {
        const res = await axios.get(`${BASE}/getUserAllotment/${exam}/${userId}`);

        return res?.data;
    } catch (error) {
        console.error("getUserPreferences error:", error?.response?.data || error.message);
    }
};

export const createPreferenceRound = async (payload) => {
    try {
        const res = await axios.post(`${BASE}/createPreferenceRound`, payload, {
            headers: {
                "Content-Type": "application/json"
            }
        });

        return res.data;
    } catch (error) {
        console.error("createPreferenceRound error:", error?.response?.data || error.message);
    }
};

export const saveUserPreferences = async (exam, payload) => {
    try {
        const res = await axios.post(`${BASE}/saveUserPreferences/${exam}`, payload, {
            headers: {
                "Content-Type": "application/json"
            }
        });

        return res.data;
    } catch (error) {
        console.error("saveUserPreferences error:", error?.response?.data || error.message);
    }
};

export const saveUserAllotment = async (payload) => {
    try {
        const response = await axios.post(
            `${BASE}/saveUserAllotment`,
            payload
        );

        return response.data;

    } catch (error) {
        console.error("Save allotment error:", error?.response?.data || error.message);
        throw error;
    }
};

export const deletePreference = async (id) => {
    try {
        const res = await axios.delete(`${BASE}/deletePreference/${id}`);
        return res.data;
    } catch (error) {
        console.error("deletePreference error:", error?.response?.data || error.message);
    }
};